import { defineComponent as u, ref as r, onServerPrefetch as f, onMounted as m, watch as s, h as c } from "vue";
import { extractRootHtmlElement as v } from "@scalar-org/vue-render";
import { fetchAsset as h } from "./resolveAndFetchIcon.js";
import { resolveLibraryIcon as d } from "../libraries/index.js";
function g(e) {
  e.target instanceof HTMLElement && (e.target.style.visibility = "hidden");
}
function o(e) {
  const t = d(e);
  return t || e;
}
const L = u({
  props: ["src", "title", "mask"],
  setup(e) {
    const t = r(o(e.src)), a = r();
    console.log("GuideIcon setup", e.src, t.value);
    function l(n) {
      t.value = o(n);
    }
    async function i(n) {
      a.value = await h(n);
    }
    return f(async () => await i(t.value)), m(async () => !a.value && await i(t.value)), s(() => e.src, l), s(t, i), () => {
      if (a.value) {
        const n = v(a.value);
        if (n.tagName === "svg")
          return c(n.tagName, {
            ...n.properties,
            width: e.size,
            height: e.size,
            class: { ...n.properties.class, ...e.classes },
            innerHTML: n.innerHTML
          });
      }
      return c("img", {
        // Only render the URL (props.src might be an icon key)
        src: t.value,
        alt: e.title,
        width: e.size,
        height: e.size,
        style: "object-fit: contain;",
        class: e.classes,
        onError: g
      });
    };
  }
});
export {
  L as GuideIcon
};
